import { render } from "./chooseRentOrSale.vue?vue&type=template&id=3be56b8c&scoped=true"
import script from "./chooseRentOrSale.vue?vue&type=script&lang=js"
export * from "./chooseRentOrSale.vue?vue&type=script&lang=js"

import "./chooseRentOrSale.vue?vue&type=style&index=0&id=3be56b8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be56b8c"]])

export default __exports__